import bus from "@/bus";
import pixelDb from "./pixelDb";
import analyticsDb from "./analyticsDb";
import pxRunner from "./runner";
import { ON_ROUTE } from "../config/constants/mutation-types";

const pixels = {
  initProvider(key, provider, Vue) {
    pxRunner.enableProvider(provider, () => {
      Vue.$log.info(
        `se habilitó el provider: ${key}. Ejecutando la cola de pxs probablemente llamados`
      );

      if (provider.queue && provider.queue.length > 0) {
        for (const task of provider.queue) {
          Vue.$log.info(`Procesando cola de provider: ${key}`);
          task();
        }
      }
    });
  },
  install(Vue) {
    for (let key in pixelDb.providers) {
      pixels.initProvider(key, pixelDb.providers[key], Vue);
    }

    // Inicio los providers de analytics
    for (let key in analyticsDb.providers) {
      pixels.initProvider(key, analyticsDb.providers[key], Vue);
    }

    /**
     * Los providers de pixeles escuchan mutations
     */
    bus.$on("mutation", mutationObj => {
      let mutation = mutationObj.mutation;
      // Hay un trigger para este tipo de mutation ?
      let trigger = pixelDb.triggers[mutation.type];
      if (trigger) {
        // El trigger 'ON_ROUTE' lleva el nombre del route, dentro del payload
        let phases = null;
        if (mutation.type === ON_ROUTE) {
          phases = trigger[mutation.payload.name];
        } else {
          phases = trigger;
        }
        // Trigger comodín
        if (trigger["*"]) {
          phases = [...phases, ...trigger["*"]];
        }
        // Si tiene phases avanzo
        if (phases) {
          for (const phase of phases) {
            pxRunner.run(phase, mutationObj, pixelDb);
          }
        }
      }
    });

    /**
     * Los providers de analytics escuchan event data
     */
    bus.$on("analytics:event", data => {
      Vue.$log.info("analytics:event", data);
      // Hay un trigger para este tipo de event ?
      let trigger = analyticsDb.triggers[data.event];
      if (trigger) {
        let phases = [];
        if (data.event === "route_change") {
          /** Los eventos de ruta tienen un método to y un from */
          phases = [
            ...(trigger["to"][data.eventData.to.name] || []),
            ...(trigger["from"][data.eventData.from.name] || [])
          ];
        } else {
          phases = trigger;
        }
        // Si tiene phases avanzo
        if (phases?.length) {
          for (const phase of phases) {
            if (phase) {
              pxRunner.run(phase, data.eventData, analyticsDb);
            }
          }
        }
      }
    });
  }
};

export default pixels;
